import React from 'react';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { AVULSO_ITEMS, WASHPASS_ITEMS } from '../../../utils/homeData';
import './OQueMudaSection.scss';

interface Props {
  onScrollToPlans: () => void;
}

export function OQueMudaSection({ onScrollToPlans }: Props) {
  return (
    <section className="o-que-muda-section">
      <div className="o-que-muda-section__header">
        <div className="section-eyebrow section-eyebrow--indigo">❯ O QUE MUDA</div>
        <h2 className="section-title">Lavar o carro deixou de ser uma decisão semanal</h2>
      </div>
      <p className="o-que-muda-section__description">
        O mercado sempre vendeu lavagem como serviço avulso: você escolhe o lugar toda vez, encara fila e paga um preço diferente a cada semana. A WashPass inverteu isso.
      </p>

      <div className="o-que-muda-section__cards">
        <div className="o-que-muda-section__card o-que-muda-section__card--avulso">
          <div className="o-que-muda-section__card-label o-que-muda-section__card-label--red">
            Do jeito avulso
          </div>
          <div className="o-que-muda-section__card-title o-que-muda-section__card-title--dark">
            Toda semana, a mesma decisão
          </div>
          {AVULSO_ITEMS.map((item) => (
            <div key={item} className="o-que-muda-section__item o-que-muda-section__item--avulso">
              <Cancel sx={{ fontSize: 16, color: '#E83C3C', flexShrink: 0, display: 'block', mt: '2px' }} />
              <span>{item}</span>
            </div>
          ))}
        </div>

        <div className="o-que-muda-section__card o-que-muda-section__card--washpass">
          <div className="o-que-muda-section__card-label o-que-muda-section__card-label--blue">
            Com a WashPass
          </div>
          <div className="o-que-muda-section__card-title o-que-muda-section__card-title--white">
            Já está contratada. É só usar.
          </div>
          {WASHPASS_ITEMS.map((item) => (
            <div key={item} className="o-que-muda-section__item o-que-muda-section__item--washpass">
              <CheckCircle sx={{ fontSize: 16, color: '#22A088', flexShrink: 0, display: 'block', mt: '2px' }} />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="o-que-muda-section__cta">
        <button className="btn-cta-green" onClick={onScrollToPlans}>
          <DirectionsCarIcon sx={{ fontSize: 20 }} />
          Assine já
        </button>
      </div>
    </section>
  );
}
